/**
 * Relationship type enum for trust account details
 */
export enum RelationshipType {
  FIRST_PROJECT = 'first_project',
  FEW_PROJECTS = 'few_projects',
  ONGOING_COLLAB = 'ongoing_collab'
}

/**
 * Time length enum for trust account details
 */
export enum TimeLength {
  UP_TO_1W = 'up_to_1w',
  W1_M1 = 'w1_m1',
  M1_M3 = 'm1_m3',
  GT_3M = 'gt_3m'
}

/**
 * Project type enum for trust accounts
 */
export enum TrustPurpose {
  SEVEN_PERCENT = 'seven_percent',
  GENERAL_SALE = 'general_sale',
  OPTIONS = 'options'
}

/**
 * Trust status enum for trust account details
 */
export enum TrustStatus {
  SETUP_IN_PROGRESS = 'setup_in_progress',
  PENDING_VALIDATION = 'pending_validation',
  IN_REVIEW = 'in_review',
  CLARIFICATION_REQUIRED = 'clarification_required',
  ACTIVATION_PENDING = 'activation_pending',
  TRUST_ACTIVE = 'trust_active'
}

/**
 * Activation status enum for trust account details
 */
export enum ActivationStatus {
  DRAFT = 'draft',
  SUBMITTED_FOR_REVIEW = 'submitted_for_review',
  APPROVED = 'approved'
}

/**
 * Operational status enum for trust account details (Derived)
 */
export enum OperationalStatus {
  SETUP = 'setup',
  PREPARING = 'preparing',
  OPEN = 'open'
}

/**
 * Package status enum for trust account details
 */
export enum PackageStatus {
  NOT_SUBMITTED = 'not_submitted',
  SUBMITTED = 'submitted',
  IN_REVIEW = 'in_review',
  CLARIFICATION_REQUIRED = 'clarification_required',
  APPROVED = 'approved'
}

/**
 * Package type enum for activation packages
 */
export enum PackageType {
  TRUST_DETAILS = 'trust_details',
  KYC = 'kyc',
  COMPLIANCE = 'compliance'
}

/**
 * Package ownership enum - who is responsible for the package
 */
export enum PackageOwnership {
  CUSTOMER = 'customer',
  SOLLAPAY = 'sollapay'
}

/**
 * Payout type enum for trust scope details
 */
export enum PayoutType {
  FUNDED_BANK = 'funded_bank',
  /** @deprecated Stored and sent as `SELLER_BANK_ACCOUNT`; still accepted from older clients. */
  DEVELOPER_BANK_ACCOUNT = 'developer_bank_account',
  SELLER_BANK_ACCOUNT = 'seller_bank_account',
  TRUSTEE = 'trustee',
  SUPPLIER = 'supplier',
  AUTHORITIES = 'authorities',
  OPTION_HOLDER = 'option_holder',
  OTHER = 'other'
}

/**
 * Payin type enum for trust scope details
 */
export enum PayinType {
  BUYERS = 'buyers',
  OTHER = 'other'
}

/**
 * Legal form of a selling party (trust seller details)
 */
export enum SellerType {
  CORPORATION = 'corporation',
  INDIVIDUAL = 'individual'
}

/**
 * Tax residency enum for developer and buyer details
 */
export enum TaxResidency {
  ISRAEL = 'israel',
  OTHER = 'other'
}
